/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InApp/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import Tysiav2DesktopChat from 'DesignSystem/Svgs/Tysiav2DesktopChat/index'



/** @type {import('Simple/types.js').View} */
export default function InApp({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/InApp",
  onClick
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 size="small"
 type="secondary"
 marginRight={dtSpaceXxs}
 marginTop={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2DesktopChat
{...childProps}
  viewPath={`${viewPath}/Tysiav2DesktopChat`}
 width={13}
 height={13}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Secure message"
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}